const logger =
  import.meta.env.NODE_ENV === 'development'
    ? console
    : {
        log: () => {},
        error: () => {},
        warn: () => {},
        info: () => {},
        debug: () => {},
      };

export default logger;
